<div class="py-2">
  <div class="input-group mb-3">
    <div class="flex-fill">
      <app-multi-select-with-service
        *ngIf="_tableDisplayConfig!.tableConfig.id && showFavorites && formControl"
        [formControl]="formControl"
        [searchOnField]="'title'"
        [reloadEmitter]="reloadFavorites"
        [service]="tableFilterFavoriteService"
        [filters]="{'table_id': _tableDisplayConfig!.tableConfig!.id}"
        [inline]="false"
        [small]="false"
        [closeDropDownOnSelection]="true"
        [sort]="'title'"
        [name]="'favorites'"
        [placeholder]="'table_filter.favorites' | translate"
        [selectionMode]="'single_model'"
      ></app-multi-select-with-service>
    </div>
    <button
      (click)="deleteFavorite()"
      class="btn btn-outline-secondary"
      [disabled]="!formControl.value?.at(0)?.id"
      type="button"
    >
      <i class="fa fa-trash-alt"></i>
    </button>
  </div>

</div>
